// extracted by mini-css-extract-plugin
module.exports = {"Aside":"Aside_Aside__1m_MY"};